/** Tenant detail /metering/tenant/detail/:id (detail.vue) */
export default {
  tenantDetailPage: {
    btnCopy: 'Copy',
    totalAssets: 'Total assets',
    electricAccount: 'Electricity account',
    waterAccount: 'Water account',
    detailCash: 'Cash',
    detailDeduction: 'Credit / deduction',
    watermarkNoAccount: 'Not opened',
    labelPublicArea: 'Leased area:',
    labelPostPayComment: 'Postpaid remark:',
    labelElectricAlarm1: 'Electricity alert threshold 1:',
    labelElectricAlarm2: 'Electricity alert threshold 2:',
    labelElectricOverdraw: 'Electricity overdraft:',
    labelWaterAlarm1: 'Water alert threshold 1:',
    labelWaterAlarm2: 'Water alert threshold 2:',
    labelWaterOverdraw: 'Water overdraft:',
    labelCreateTime: 'Opened at:',
    labelPhone: 'Phone:',
    labelPhoneN: 'Phone {n}:',
    btnCloseAccount: 'Close account',
    btnRecharge: 'Top up',
    btnDeduct: 'Debit',
    btnEdit: 'Edit',
    tabDevice: 'Devices',
    tabStatistics: 'Energy',
    tabBill: 'Bills',
    tabTurnover: 'Transactions',
    tabRefund: 'Refunds',
    tabInvoice: 'Invoices',
    invoiceRecords: {
      refresh: 'Refresh',
      appliedAt: 'Applied at',
      subject: 'Fee type',
      method: 'Billing method',
      title: 'Invoice title',
      amount: 'Amount',
      status: 'Status',
      invoiceNo: 'Invoice number',
      actions: 'Actions',
      detail: 'Details',
      empty: 'No invoices',
      loadFailed: 'Could not load invoices',
      scopeMismatch: 'The returned invoices do not match the current tenant'
    },
    emptyNotOpen: 'Coming soon',
    msgNoViewPerm: 'No permission to view',
    msgTenantIdEmpty: 'Tenant ID is required',
    msgTenantNotFound: 'Tenant not found',
    msgFetchFail: 'Failed to load tenant',
    msgIdEmpty: 'Tenant ID is empty',
    msgCopyOk: 'Copied',
    msgCopyFail: 'Copy failed',
    msgNoClosePerm: 'No permission to close account',
    msgCloseNotSupported: 'Closing this tenant is not supported',
    msgNoRechargePerm: 'No permission to top up',
    msgNoDeductPerm: 'No permission to debit',
    msgNoEditPerm: 'No permission to edit'
  }
}
